export const PROFILE_EMPLOYER_COMPANY_LOGO_UPLOAD_REQUEST =
  'profile/employer-company-logo-upload-request'
export const PROFILE_EMPLOYER_COMPANY_LOGO_UPLOAD_SUCCESS =
  'profile/employer-company-logo-upload-success'
export const PROFILE_EMPLOYER_COMPANY_LOGO_UPLOAD_FAILED =
  'profile/employer-company-logo-upload-failed'
